import { FC } from "react";
import { InfoDialog } from "../alerts";
import { validateClient } from "lib/clients";
import { useToastNotification } from "lib/hooks";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  content: string;
  title: string;
}

export const VerifyAlertDialog: FC<Props> = ({ isOpen, onClose, content, title }) => {
  const { errorToast, infoToast } = useToastNotification();

  const resendEmail = async (): Promise<void> => {
    try {
      await validateClient.validateEmail();
      onClose();
      infoToast({
        title: 'Email sent',
        description: 'Please check your inbox for the verification email'
      })
    } catch (err) {
      errorToast({
        title: 'Error',
        description: 'Unable to resend verification email',
      })
    }
  }

  return (
    <InfoDialog
      isOpen={isOpen}
      onClose={onClose}
      onClick={resendEmail}
      content={content}
      title={title}
      primaryButtonText={"Resend verification email"}
    />
  )
}